// extracted by mini-css-extract-plugin
export default {"chart_block":"IssueStats_chart_block__vYPR3","metric_block":"IssueStats_metric_block__4xeo8","metric_block_other_container":"IssueStats_metric_block_other_container__wuUPi"};